__turbopack_export_value__({
  "body-logo-18": "OpeningItem-module-scss-module__OcGPNW__body-logo-18",
  "body-text-12": "OpeningItem-module-scss-module__OcGPNW__body-text-12",
  "body-text-14": "OpeningItem-module-scss-module__OcGPNW__body-text-14",
  "body-text-16": "OpeningItem-module-scss-module__OcGPNW__body-text-16",
  "body-text-18": "OpeningItem-module-scss-module__OcGPNW__body-text-18",
  "body-text-20": "OpeningItem-module-scss-module__OcGPNW__body-text-20",
  "body-text-24": "OpeningItem-module-scss-module__OcGPNW__body-text-24",
  "body-text-24-2": "OpeningItem-module-scss-module__OcGPNW__body-text-24-2",
  "body-text-heading-2": "OpeningItem-module-scss-module__OcGPNW__body-text-heading-2",
  "body-text-heading-3": "OpeningItem-module-scss-module__OcGPNW__body-text-heading-3",
  "body-text-medium-14": "OpeningItem-module-scss-module__OcGPNW__body-text-medium-14",
  "body-text-medium-16": "OpeningItem-module-scss-module__OcGPNW__body-text-medium-16",
  "body-text-medium-18": "OpeningItem-module-scss-module__OcGPNW__body-text-medium-18",
  "body-text-medium2-18": "OpeningItem-module-scss-module__OcGPNW__body-text-medium2-18",
  "body-text2-14": "OpeningItem-module-scss-module__OcGPNW__body-text2-14",
  "body-text2-16": "OpeningItem-module-scss-module__OcGPNW__body-text2-16",
  "button-primary-text": "OpeningItem-module-scss-module__OcGPNW__button-primary-text",
  "button-text": "OpeningItem-module-scss-module__OcGPNW__button-text",
  "button2-text": "OpeningItem-module-scss-module__OcGPNW__button2-text",
  "card-shadow": "OpeningItem-module-scss-module__OcGPNW__card-shadow",
  "effect-menu": "OpeningItem-module-scss-module__OcGPNW__effect-menu",
  "header-1": "OpeningItem-module-scss-module__OcGPNW__header-1",
  "item": "OpeningItem-module-scss-module__OcGPNW__item",
  "item__arrow": "OpeningItem-module-scss-module__OcGPNW__item__arrow",
  "item__arrow__opened": "OpeningItem-module-scss-module__OcGPNW__item__arrow__opened",
  "item__body": "OpeningItem-module-scss-module__OcGPNW__item__body",
  "item__bodyInner": "OpeningItem-module-scss-module__OcGPNW__item__bodyInner",
  "item__body_opened": "OpeningItem-module-scss-module__OcGPNW__item__body_opened",
  "item__doc": "OpeningItem-module-scss-module__OcGPNW__item__doc",
  "item__head": "OpeningItem-module-scss-module__OcGPNW__item__head",
  "item__text": "OpeningItem-module-scss-module__OcGPNW__item__text",
  "main-container": "OpeningItem-module-scss-module__OcGPNW__main-container",
  "main-footer-container": "OpeningItem-module-scss-module__OcGPNW__main-footer-container",
  "main-header-container": "OpeningItem-module-scss-module__OcGPNW__main-header-container",
  "overflow": "OpeningItem-module-scss-module__OcGPNW__overflow",
  "txt-12-bold": "OpeningItem-module-scss-module__OcGPNW__txt-12-bold",
  "txt-14-bold": "OpeningItem-module-scss-module__OcGPNW__txt-14-bold",
  "txt-14-bold-caps": "OpeningItem-module-scss-module__OcGPNW__txt-14-bold-caps",
  "txt-14-med": "OpeningItem-module-scss-module__OcGPNW__txt-14-med",
  "txt-16-bold": "OpeningItem-module-scss-module__OcGPNW__txt-16-bold",
  "txt-16-med": "OpeningItem-module-scss-module__OcGPNW__txt-16-med",
  "txt-18-bold": "OpeningItem-module-scss-module__OcGPNW__txt-18-bold",
  "txt-18-medium": "OpeningItem-module-scss-module__OcGPNW__txt-18-medium",
  "txt-18-medium-24": "OpeningItem-module-scss-module__OcGPNW__txt-18-medium-24",
  "txt-24-semi": "OpeningItem-module-scss-module__OcGPNW__txt-24-semi",
});
